import { call, put } from 'redux-saga/effects';
import { assignAdvancedUserRightsToAll } from '../api';
import {
  assignAdvancedUserRightToAllSuccess,
  assignAdvancedUserRightToAllFailure,
} from '../actions';
import { AssignAdvancedUserRightToAllRequestAction } from '../types';

export function* assignAdvancedUserRightToAllSaga(
  action: AssignAdvancedUserRightToAllRequestAction
): Generator {
  try {
    const { accountId, organisationIds, operationIds } = action.payload;
    yield call(
      assignAdvancedUserRightsToAll,
      accountId,
      organisationIds,
      operationIds
    );
    yield put(assignAdvancedUserRightToAllSuccess());
  } catch (error) {
    yield put(assignAdvancedUserRightToAllFailure());
  }
}
